import React from 'react';

import { Container, Button, Image } from 'react-bootstrap';

import {
  PlaidLink,
  PlaidLinkOnSuccess,
  PlaidLinkOnEvent,
  PlaidLinkOnExit,
} from 'react-plaid-link';

import ReactLoading from 'react-loading';

import { PlaidAPI } from '../../api/plaidAPI';

// Importing custom css
import '../signinComponent/signin.css';

// Importing logo
import logo from "../../assets/images/Undebted_logo.png";

// Importing success icon
//import success from '../../assets/images/success.gif';
import Lottie from 'lottie-react';
import success from '../../assets/success.json';

interface Props {
  clientID: string;
  apiKey: string;
  name: string;
}

interface State {
  token: null;
  success: boolean;
  pending: boolean;
}

class PlaidLinkClass extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = { 
      token: null,
      success: false,
      pending: false,
    };
  }
  
  /**
   * Function that calls the server to acquire a link token to access Link for the client
   */
  createLinkToken() {
    //API call to get Link Token
    PlaidAPI.get_link_token().then((response) => {

        const link_token = response.data.link_token;
        this.setState({ token: link_token });

        //console.log("Link Token: " + link_token);
    }).catch((error) => {
        console.log(error);
    });
  }

  /**
   * Function that calls the server to exchange a public token for a permanent access token
   */
  exchangeToken(public_token: string) {

    this.setState({ pending: true });

    //API call to get Link Token
    PlaidAPI.exchange_token(public_token, this.props.clientID, this.props.apiKey).then((response) => {

        //Print out props
        console.log(response);

        if (response.status === 200) {
          //console.log("Success");
          this.setState({ pending: false });
          this.setState({ success: true });
        }
    }).catch((error) => {
        console.log(error);
    });
  }

  async componentDidMount() {
    this.createLinkToken();
  }


  onSuccess: PlaidLinkOnSuccess = (publicToken, metadata) => {
    // send public_token to your server
    // https://plaid.com/docs/api/tokens/#token-exchange-flow
    //console.log("Public Token: " + publicToken);
    
    this.exchangeToken(publicToken);
  };

  onEvent: PlaidLinkOnEvent = (eventName, metadata) => {
    // log onEvent callbacks from Link
    // https://plaid.com/docs/link/web/#onevent
    //console.log(eventName, metadata);
  };

  onExit: PlaidLinkOnExit = (error, metadata) => {
    // log onExit callbacks from Link, handle errors
    // https://plaid.com/docs/link/web/#onexit
    //console.log(error, metadata);
  };

  render() {

    //console.log("Success: " + this.state.success);

    if ((this.state.success) && (!this.state.pending)) {
      return (
        <Container className='container'>
            <div className="main">
            <Image 
              src={logo} 
              className='undebted_logo' 
              alt="Undebted Logo" 
              style={{ display: 'block', margin: '0 auto', width: '30%' }} 
            />
            <div className="lottieAlign">
              <Lottie animationData={success} className="lottieStyle"/>
            </div>
            <span className='lottieText'>You have successfully linked your bank account with Undebted.</span>
            </div>
        </Container>
      );
    }
    else if (this.state.pending) {
      return (
        <Container className='container'>
          <div className="main">
            <Image 
              src={logo} 
              className='undebted_logo' 
              alt="Undebted Logo" 
              style={{ display: 'block', margin: '0 auto', width: '30%' }} 
            />
            <ReactLoading type="balls" color="#000" height={'100%'} width={'50%'}/>
            <h3>Linking your bank account ...</h3>
          </div>
        </Container>
      );
    }
    else {
      return (
        <Container className='container'>
          <div className="main">
           <Image 
              src={logo} 
              className='undebted_logo' 
              alt="Undebted Logo" 
              style={{ display: 'block', margin: '0 auto', width: '30%' }} 
            />
            <h1>{ this.props.clientID === undefined || this.props.clientID === null  ? "No Record Found" : "Welcome " + this.props.name }</h1>
            { this.props.clientID !== undefined && this.props.clientID !== null ?
              <PlaidLink
                className="link_button"
                token={this.state.token}
                onSuccess={this.onSuccess}
                onEvent={this.onEvent}
                onExit={this.onExit}
              >
                Secure Login
            </PlaidLink> :
            <Button variant="dark" className="button" onClick={() => { window.location.reload() }}>
                Go Back
            </Button>
            }
          </div>
        </Container>
      );
    }
  }
}

export default PlaidLinkClass;

    

   